import { useTenant } from "@/hooks/useTenant";
import { portalFetch } from "@/lib/portalApi";
import { useQuery } from "@tanstack/react-query";

/** Whether SimplySpark is on for the current tenant: its setting is on AND it has a BI credential. */
export function useSparkEnabled(): { enabled: boolean; isLoading: boolean } {
  const { currentTenantId } = useTenant();
  const { data, isLoading } = useQuery({
    queryKey: ["spark-enabled", currentTenantId],
    queryFn: () =>
      portalFetch<{ enabled: boolean }>(`/api/portal/tenants/${currentTenantId}/spark`),
    enabled: !!currentTenantId,
    staleTime: 5 * 60 * 1000,
  });
  return { enabled: data?.enabled ?? false, isLoading };
}
